/**
 * Draw page constants (from excalidraw-master app_constants, minimal set for frontend-only draw).
 */

export const DRAW_STORAGE_KEYS = {
  SCENE: "excalidraw-draw-scene",
  THEME: "excalidraw-draw-theme",
} as const;

/** Theme type matching excalidraw (light | dark). */
export type DrawTheme = "light" | "dark";
